import { API } from 'api';
import { useMutation } from 'react-query';

interface IRevertPoints {
  payload: {
    transactionId: string;
    description?: string;
    ebid?: string;
  };
}

export const revertPoints = (payload: IRevertPoints['payload']) => {
  let queryParams = '';
  if (payload.ebid) {
    queryParams = `?ebid=${payload.ebid}`;
  }

  return API.post()(`/api/admin/reward/revert/${payload.transactionId}${queryParams}`, {
    description: payload?.description,
  });
};

export const useRevertPoints = () =>
  useMutation(revertPoints, {
    onSuccess: (response) => response.data,
  });
